import axios from "axios";

export default {
    getAll() {
        let tokenAuth = localStorage.getItem("access_token");
        let headerAuth = { headers: { Authorization: `${tokenAuth}` } };

        return axios
            .get("api/clientes", headerAuth)
            .then((result) => {
                return result.data;
            })
            .catch((e) => {
                console.log(e);
                throw e;
            });
    },
    getAllBySucursal(sucursalId) {
        let tokenAuth = localStorage.getItem("access_token");
        let headerAuth = { headers: { Authorization: `${tokenAuth}` } };

        return axios
            .get(`api/clientes/sucursal/${sucursalId}`, headerAuth)
            .then((result) => {
                let clientes = result.data;
                clientes = clientes.sort((a, b) => b.clienteId - a.clienteId);
                return result.data;
            })
            .catch((e) => {
                console.log(e);
                throw e;
            });
    },

    get(id) {
        let tokenAuth = localStorage.getItem("access_token");
        let headerAuth = { headers: { Authorization: `${tokenAuth}` } };

        return axios
            .get(`api/cliente/${id}`, headerAuth)
            .then((result) => {
                return result.data;
            })
            .catch((e) => {
                console.log(e);
                throw e;
            });
    },

    add(cliente) {
        let tokenAuth = localStorage.getItem("access_token");
        let headerAuth = { headers: { Authorization: `${tokenAuth}` } };

        return axios
            .post("api/cliente", cliente, headerAuth)
            .then((result) => {
                return result.data;
            })
            .catch((e) => {
                console.log(e);
                throw e;
            });
    },

    update(cliente) {
        let tokenAuth = localStorage.getItem("access_token");
        let headerAuth = { headers: { Authorization: `${tokenAuth}` } };

        return axios
            .put(`api/cliente/${cliente.clienteId}`, cliente, headerAuth)
            .then((result) => {
                return result.data;
            })
            .catch((e) => {
                console.log(e);
                throw e;
            });
    },

    delete(id) {
        let tokenAuth = localStorage.getItem("access_token");
        let headerAuth = { headers: { Authorization: `${tokenAuth}` } };

        return axios
            .delete(`api/cliente/${id}`, headerAuth)
            .then((result) => {
                return result.data;
            })
            .catch((e) => {
                console.log(e);
                throw e;
            });
    },

    addPublic(cliente) {

        cliente.usuarioId = localStorage.getItem("usuarioId");
        cliente.token = localStorage.getItem("tokenAcceso");

        return axios
            .post("api/cliente-public", cliente)
            .then((result) => {
                return result.data;
            })
            .catch((e) => {
                console.log(e);
                throw e;
            });
    },
};